module.exports = __webpack_public_path__ + "5c7607025499c9c20f3b744be6b13beb.png";